<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <vue-dropbox-picker
      v-show="(multiselect ? true : (!model ? true : false))"
      api-key="3il3pbn8nb1awtd"
      link-type="direct"
      :folderselect="false"
      :extensions="extensions"
      :multiselect="(multiselect ? multiselect : false)"
      @cancel="onCancel"
      @picked="onPicked"
    >
      <v-avatar
        v-if="avatar"
        color="primary"
        rounded
        height="auto"
        style="cursor: pointer;aspect-ratio: 1 / 1;min-width: 75px !important;"
      >
        <v-icon
          style="font-size: 28px"
          dark
        >
          mdi-account-circle
        </v-icon>
      </v-avatar>
      <v-btn
        v-if="!avatar"
        dark
        small
        outlined
        height="32"
        color="blue"
        style="width: 100%"
      >
        <v-icon dark>
          mdi-dropbox
        </v-icon>
        {{ (title ? $t(title) : $t('dropbox')) }}
      </v-btn>
    </vue-dropbox-picker>
    <div
      v-if="!model"
      style="font-size: 10px"
      align="center"
    >
      {{ (sizeLimit ? 'max :' + sizeLimit + 'kb': '') }}
    </div>
    <v-list
      v-if="!avatar"
      class="ma-0"
    >
      <v-list-item
        v-for="(file, index) in files"
        :key="index"
        class="pa-0"
        link
      >
        <v-list-item-avatar
          rounded
          @click="open(file)"
        >
          <v-img
            :alt="`${file.title} avatar`"
            :src="(file.extension === '. jpg' ? file.link :file.iconURL)"
          />
        </v-list-item-avatar>

        <v-list-item-content
          @click="open(file)"
        >
          <v-list-item-title v-text="file.title" />
          <v-list-item-subtitle
            style="font-size: 11px"
            v-text="'file size : ' + file.size + ' bytes'"
          />
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon @click="remove(file, index)">
            mdi-close
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <div
      v-if="avatar && model"
      style="display: flex"
      :style="{width : ($vuetify.breakpoint.mobile ? '75px' : '100%')}"
    >
      <v-avatar
        rounded
        height="auto"
        width="100%"
        style="cursor: pointer;aspect-ratio: 1 / 1;min-width: 75px !important;"
        @click="open(model)"
      >
        <img
          style="aspect-ratio:1/1"
          :src="model.link"
          :alt="model.title"
        >
      </v-avatar>
      <v-btn
        color="pink"
        fab
        elevation="1"
        left
        style="top: -6px;left: 9px;min-width: 15px !important;z-index: 2;width: 20px;height: 20px"
        class="pa-0 flex-column-reverse"
        @click="removeAvatar"
      >
        <v-icon small>
          mdi-close
        </v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
  import VueDropboxPicker from 'vue-dropbox-chooser'
  export default {
    name: 'Product',
    components: {
      VueDropboxPicker,
    },
    props: ['multiple', 'val', 'extensions', 'avatar', 'title', 'sizeLimit', 'multiselect'],
    data: () => ({
      model: null,
      files: null,
    }),
    watch: {
      val () {
        this.files = this.val
        this.model = this.val
      },
      model () {
      },
    },
    mounted () {
      if (this.val) {
        this.files = this.val
        this.model = this.val
      }
    },
    methods: {
      open (file) {
        window.open(file.link, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,width=600,height=500')
      },
      removeAvatar () {
        this.model = null
        this.$emit('input', this.model)
      },
      remove (item, index) {
        var i = this.files.indexOf(item)
        this.files.splice(i, 1)
        if (this.multiselect) {
          this.$emit('input', this.files)
          this.model = this.files
        } else {
          this.model = null
          this.$emit('input', this.model)
        }
      },
      onCancel () {
      },
      onPicked (files) {
        this.files = files
        if (this.multiselect) {
          if (this.model == null) {
            this.model = []
          }
          this.model = [
            ...this.model,
            ...files,
          ]
          this.$emit('input', this.model)
          // this.model.push(files)
        } else {
          this.$emit('input', files[0])
          this.model = files[0]
        }
      },
    },
  }
</script>

<style scoped>

</style>
